module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var util = require('util/Util.js').default; 
    ; __append("\r\n<div class=\"prop-header\">\r\n    <span class=\"prop-label\">Page Turning</span>\r\n</div>\r\n<div class=\"row prop-detail\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 form-group-flex\">\r\n            <input type=\"checkbox\" id=\"'pageTopScroll\" name=\"pageTopScroll\" ")
    ; __append(escapeFn(util.isTrue(pageTopScroll)? 'checked' :''))
    ; __append(" class=\"form-radio-group\"/>\r\n            <label class=\"form-group-label\">Auto-scroll to top of page</label>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}